<template>
  <div>
    <CCard class="sd_card">
      <CCardBody>
        <div v-if="topForm">
          <CAlert show color="info"
            >新しいEメールアドレスを入力してください。</CAlert
          >
          <CForm class="member-info modal-form">
            <CRow>
              <CCol>
                <CInput
                  type="email"
                  label="新Eメールアドレス"
                  horizontal
                  v-model="newEmail"
                />

                <CAlert
                  show
                  color="danger"
                  v-if="$v.newEmail.$dirty && !$v.newEmail.required"
                >
                  新Eメールアドレスは必須です
                </CAlert>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CButton
                  class="info-button shadow-sm"
                  v-on:click="
                    $v.newEmail.$invalid
                      ? requiredM()
                      : submitUpdateEmail('Eメールアドレス更新')
                  "
                  v-bind:class="$v.newEmail.$invalid ? 'inactive' : 'active'"
                >
                  <i class="icon cil-envelope-closed"></i> Eメールアドレス更新
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </div>
        <div v-if="ConfirmModal">
          <CAlert show color="success"
            ><p>
              {{
                ModalTitle
              }}のEメールアドレスを登録したEメールアドレスに送信しました。
              <br />Eメールアドレスを確認してリンクに従って更新してください。
            </p></CAlert
          >
          <CButton
            class="mt-4 p-center"
            onclick="window.location.reload();"
            color="success"
            ><i class="icon cil-arrow-left"></i> 戻る</CButton
          >
        </div>
      </CCardBody>
    </CCard>

    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="errorModal"
    >
      <p>{{ errorMessage }}</p>
      <template #header>
        <h4 class="modal-title">Error</h4>
      </template>
      <template #footer>
        <CButton @click="errorModal = false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
const alphaNumValidator = helpers.regex(
  "EmailValidator",
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export default {
  name: "アプリ会員情報",
  data() {
    return {
       
      newEmail: "",
      ModalTitle: "",
      errorMessage: "",
      editingModal: false,
      ConfirmModal: false,
      successModal: false,
      errorModal: false,
      topForm: true,
    };
  },
  validations: {
    newEmail: { required, maxLength: maxLength(100), alphaNumValidator },
  },

  methods: {
    submitUpdateEmail: function (title) {
      this.ModalTitle = title;

      var userInfoE = {
        username: this.$keycloak.userName,
        email: this.newEmail,
      };
      var urlRequestE = "/rest/users/" + this.$keycloak.userName + "/email";
      axios
        .put(urlRequestE, userInfoE, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp);
          this.topForm = false;
          this.ConfirmModal = true;
          this.newEmail = "";
        })
        .catch((err) => {
           

          this.errorMessage = err;
          this.errorModal = true;
        });
    },

    requiredM() {
      this.$v.newEmail.$touch();
    },
  },
};
</script>
<style lang="scss">
.sp_card {
  border: none;
}
.card {
  border: none;
  .card-body {
    .alert {
      font-size: 0.85rem;
    }
    .form-row {
      margin: 0 0 1rem;
    }
  }
}
.p-center {
  margin: 0 auto;
  display: table;
}
.btn{
  min-width: 45%;
}
</style>


